import { render, staticRenderFns } from "./BuildingNotes.vue?vue&type=template&id=78729f94&scoped=true"
import script from "./BuildingNotes.vue?vue&type=script&lang=js"
export * from "./BuildingNotes.vue?vue&type=script&lang=js"
import style0 from "./BuildingNotes.vue?vue&type=style&index=0&id=78729f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.108.4_postcss@8.5.19___ejs@3.1.10_lodash@4.18._z5rsh3vccqgauevuorosu7p4fm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78729f94",
  null
  
)

export default component.exports